
import React, { useState } from 'react';

const CHOICES = [
  { name: 'Rock', icon: '✊', beats: 'Scissors' },
  { name: 'Paper', icon: '✋', beats: 'Rock' },
  { name: 'Scissors', icon: '✌️', beats: 'Paper' }
];

const RPS: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [ai, setAi] = useState<any>(null);
  const [result, setResult] = useState<string>("");

  const play = (choice: any) => {
    const aiChoice = CHOICES[Math.floor(Math.random() * 3)];
    setUser(choice);
    setAi(aiChoice);
    if (choice.name === aiChoice.name) setResult("BUFFER COLLISION (DRAW)");
    else if (choice.beats === aiChoice.name) setResult("USER OVERRIDE (WIN)");
    else setResult("AI ENFORCED (LOSE)");
  };

  return (
    <div className="flex flex-col items-center max-w-md w-full">
      <div className="flex justify-between w-full mb-12">
        <div className="text-center">
          <p className="text-xs text-slate-500 mb-2">YOU</p>
          <div className="text-6xl p-6 bg-slate-900 rounded-3xl border border-slate-800">{user?.icon || '❓'}</div>
        </div>
        <div className="flex items-center text-4xl font-black opacity-20">VS</div>
        <div className="text-center">
          <p className="text-xs text-slate-500 mb-2">AI</p>
          <div className="text-6xl p-6 bg-slate-900 rounded-3xl border border-slate-800">{ai?.icon || '❓'}</div>
        </div>
      </div>
      <h2 className="text-xl font-black mb-12 text-blue-400">{result || "WAITING FOR INPUT..."}</h2>
      <div className="flex gap-4">
        {CHOICES.map(c => (
          <button key={c.name} onClick={() => play(c)} className="bg-slate-800 p-6 rounded-2xl text-4xl hover:bg-blue-600 transition-all transform hover:-translate-y-1">
            {c.icon}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RPS;
